/**
 * Testimonials Widget JS
 *
 * @since   1.0.0
 * @package qhub
 */
(function($) {
    // Hook for when elementor front end is loaded
    $(window).on('elementor/frontend/init', function() {
        //hook name is 'frontend/element_ready/{widget-name}.{skin}
        //$scope is a jquery wrapped parent element
        elementorFrontend.hooks.addAction('frontend/element_ready/qhub-testimonials.default', function($scope) {

            function initTestimonialsFlickity() {
                var testimonialsFlickity = $('.testimonials-slider').flickity({
                    // options
                    cellAlign: 'left',
                    prevNextButtons: false,
                    dragThreshold: 10,
                    selectedAttraction: 0.05,
                    friction: 0.8,
                    initialIndex: 0,
                });
            }

            if ($('.testimonials-slider').length > 0) {
                initTestimonialsFlickity();
                $(window).resize(initTestimonialsFlickity);
            }

        });
    });

})(jQuery);
